import { createNoise3D } from "simplex-noise";

export type Noise3D = (x: number, y: number, z: number) => number;
export function CreateNoise3D(randomSrc: () => number): Noise3D {
	return createNoise3D(randomSrc);
}
